
export const WAIT_MESSAGE_PHASES = [
  {
    key: "reading",
    untilMs: 2000,
    messages: [
      "Reading the brief",
      "Taking it in",
      "Getting the gist",
      "Sizing it up",
      "Taking stock",
      "Reading it twice",
      "Checking the detail",
      "Making sense of it",
      "Getting the shape",
      "Joining the dots",
      "Reading it properly",
      "Listening",
      "Getting the measure",
      "Seeing what you need",
      "Picking it apart",
      "Reading the small print",
      "Understanding the ask",
      "Noting the constraints",
      "Getting the context",
      "Following the thread",
    ],
  },
  {
    key: "selecting",
    untilMs: 5000,
    messages: [
      "Finding the right Agent",
      "Checking the bench",
      "Matching the work",
      "Narrowing it down",
      "Working out who",
      "Shortlisting",
      "Choosing the route",
      "Picking the right hands",
      "Ruling things out",
      "Deciding who runs it",
      "Thinking it through",
      "Ruminating",
      "Deliberating",
      "Mulling it over",
      "Turning it over",
      "Working it out",
      "Untangling it",
      "Doing the maths",
      "Squaring it up",
      "Weighing it up",
    ],
  },
  {
    key: "running",
    untilMs: Infinity,
    messages: [
      "Making the call",
      "Settling on one",
      "Lining it up",
      "Briefing the Agent",
      "Handing it over",
      "Clearing a path",
      "Putting it together",
      "Getting organised",
      "Rolling up sleeves",
      "Getting to it",
      "Setting it running",
      "Passing it across",
      "Under way",
      "Off it goes",
      "Still on it",
      "Still going",
      "Nearly there",
      "Still here",
      "Taking the extra minute",
      "Worth doing properly",
    ],
  },
];

export const phaseForElapsed = (elapsedMs) =>
  WAIT_MESSAGE_PHASES.find((phase) => elapsedMs < phase.untilMs) ||
  WAIT_MESSAGE_PHASES[WAIT_MESSAGE_PHASES.length - 1];
